import { createGlobalStyle } from 'styled-components';

export default createGlobalStyle`
.ant-card {
   && {
    box-shadow: 4px 4px 8px rgba(174, 174, 174, 0.25);
   }
}
`;
